module.exports = __webpack_public_path__ + "img/Yelp.ffab4378.svg";